import { render } from "./TheLoaderFullPage.vue?vue&type=template&id=3304af7d&scoped=true&ts=true"
import script from "./TheLoaderFullPage.vue?vue&type=script&lang=ts"
export * from "./TheLoaderFullPage.vue?vue&type=script&lang=ts"

import "./TheLoaderFullPage.vue?vue&type=style&index=0&id=3304af7d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src317777935/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3304af7d"]])

export default __exports__